export default __webpack_public_path__ + "static/media/drawback.32f9890e.jpg";